import { HugeiconsIcon } from "@hugeicons/react"
import { Search01Icon } from "@hugeicons/core-free-icons"
import { useSearchStore } from "@/features/search/stores/search-store"

export function SearchButton() {
  const open = useSearchStore((s) => s.open)

  return (
    <button
      type="button"
      onClick={open}
      aria-label="Search"
      className="flex h-8 w-full max-w-xl cursor-pointer items-center gap-2 rounded-md border border-input bg-input/20 px-3 text-muted-foreground transition-colors hover:border-ring hover:bg-input/30 dark:bg-input/30"
    >
      <HugeiconsIcon icon={Search01Icon} size={15} className="shrink-0" />
      <span className="truncate text-xs">
        Navigate. Find orders, invoices, contacts, and more.
      </span>
      <kbd className="pointer-events-none ml-auto hidden h-5 shrink-0 select-none items-center gap-1 rounded-sm border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground sm:inline-flex">
        <span className="text-xs">⌘</span>K
      </kbd>
    </button>
  )
}
